export interface IForm {}

export default class Form implements IForm {}